import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CommonServiceService {
    private previousGyanClick = new BehaviorSubject<any>(false);
    previousGyanClick$ = this.previousGyanClick.asObservable();

    private previousadvanceQueryClick = new BehaviorSubject<any>(false);
    previousadvanceQueryClick$ = this.previousadvanceQueryClick.asObservable();

    private previousGyanOnload = new BehaviorSubject<boolean>(false);
    previousGyanOnload$ = this.previousGyanOnload.asObservable();

    private createGyanInitiated = new BehaviorSubject<boolean>(false);
    createGyanInitiated$ = this.createGyanInitiated.asObservable();

    private callPreviousSearchGyan = new BehaviorSubject<boolean>(false);
    callPreviousSearchGyan$ = this.callPreviousSearchGyan.asObservable();

    public articleNetworkSubject = new BehaviorSubject<any>(null);
    articleNetworkSubject$ = this.articleNetworkSubject.asObservable();

    public articleLongStoryDataActual = new BehaviorSubject<any>(null);
    articleLongStoryDataActual$ = this.articleLongStoryDataActual.asObservable();

    public disablehighlight = new BehaviorSubject<any>(null);
    disablehighlight$ = this.disablehighlight.asObservable();

    public gotoDashboard = new BehaviorSubject<any>(false);
    gotoDashboard$ = this.gotoDashboard.asObservable();

    private articleLongStory = new BehaviorSubject<boolean>(false);
    articleLongStory$ = this.articleLongStory.asObservable();

    private loadingAfterSocket = new BehaviorSubject<boolean>(false);
    loadingAfterSocket$ = this.loadingAfterSocket.asObservable();

    public articleNetworkResetSubject = new BehaviorSubject<any>(null);
    articleNetworkResetSubject$ = this.articleNetworkResetSubject.asObservable();

    private callfromSocketForMDS = new BehaviorSubject<boolean>(false);
    callfromSocketForMDS$ = this.callfromSocketForMDS.asObservable();

    private callfromSocketArticleList = new BehaviorSubject<boolean>(false);
    callfromSocketArticleList$ = this.callfromSocketArticleList.asObservable();

    private callfromSocketArticleListSummary = new BehaviorSubject<boolean>(false);
    callfromSocketArticleListSummary$ = this.callfromSocketArticleListSummary.asObservable();

    private resetArticleList = new BehaviorSubject<boolean>(false);
    resetArticleList$ = this.resetArticleList.asObservable();

    private SelectedId = new BehaviorSubject<any>(null);
    SelectedId$ = this.SelectedId.asObservable();

    private findMoreArticleClick = new BehaviorSubject<boolean>(false);
    findMoreArticleClick$ = this.findMoreArticleClick.asObservable();

    private scrollToTop = new BehaviorSubject<any>(false);
    scrollToTop$ = this.scrollToTop.asObservable();

    private openSubmitGyan = new BehaviorSubject<any>(false);
    openSubmitGyan$ = this.openSubmitGyan.asObservable();

    private RefreshAdvancedQueries = new BehaviorSubject<any>(false);
    RefreshAdvancedQueries$ = this.RefreshAdvancedQueries.asObservable();

    private ReOpenAdvancedQueries = new BehaviorSubject<any>(false);
    ReOpenAdvancedQueries$ = this.ReOpenAdvancedQueries.asObservable();

    private showAdvancyQueryFormPage = new BehaviorSubject<any>(false);
    showAdvancyQueryFormPage$ = this.showAdvancyQueryFormPage.asObservable();

    private CallFromSocketForGyanStatus = new BehaviorSubject<any>(false);
    CallFromSocketForGyanStatus$ = this.CallFromSocketForGyanStatus.asObservable();

    private menuStateSubject = new Subject<number | null>();
    menuState$ = this.menuStateSubject.asObservable();

    private callTopicName = new BehaviorSubject<any>('');
    callTopicName$ = this.callTopicName.asObservable();

    paraIdselected: any;
    GyanStatus = new BehaviorSubject<any>(false);

    private validationForSubmitGyanFromSubtopic = new BehaviorSubject<any>(false);
    validationForSubmitGyanFromSubtopic$ = this.validationForSubmitGyanFromSubtopic.asObservable();

    public articleCountButtonClicked = new BehaviorSubject<any>(null);
    articleCountButtonClicked$ = this.articleCountButtonClicked.asObservable();

    public cancelFlag = new BehaviorSubject<any>('');
    cancelFlag$ = this.cancelFlag.asObservable();

    private showDraftListPage = new BehaviorSubject<any>(false);
    showDraftListPage$ = this.showDraftListPage.asObservable();
    private callUseAsTemplate = new BehaviorSubject<any>(null);
    callUseAsTemplate$ = this.callUseAsTemplate.asObservable();

    private templateDataSubject = new BehaviorSubject<any>(null);
    templateDataSubject$ = this.templateDataSubject.asObservable();

    private templateDataSubjectForSources = new BehaviorSubject<any>(null);
    templateDataSubjectForSources$ = this.templateDataSubjectForSources.asObservable();

    private templateDataSubjectForTopicOutline = new BehaviorSubject<any>(null);
    templateDataSubjectForTopicOutline$ = this.templateDataSubjectForTopicOutline.asObservable();

    private templateDataSubjectForConfig = new BehaviorSubject<any>(null);
    templateDataSubjectForConfig$ = this.templateDataSubjectForConfig.asObservable();

    private createUserGroupForClient = new BehaviorSubject<any>(null);
    createUserGroupForClient$ = this.createUserGroupForClient.asObservable();

    private confirmGyan = new BehaviorSubject<any>(false);
    confirmGyan$ = this.confirmGyan.asObservable();

    private calldraftLoaded = new BehaviorSubject<any>(null);
    calldraftLoaded$ = this.calldraftLoaded.asObservable();

    private templateLoaded = new BehaviorSubject<any>(false);
    templateLoaded$ = this.templateLoaded.asObservable();

    constructor() {}

    // subject for previous gyan click event
    setPreviousGyanClick(value: object) {
        this.previousGyanClick.next(value);
    }

    setPreviousadvanceQueryClick(value: object) {
        this.previousadvanceQueryClick.next(value);
    }

    // subject for previous gyan on load page
    setPreviousGyanOnload(value: boolean) {
        this.previousGyanOnload.next(value);
    }

    // subject for previous gyan on load page
    setCallPreviousSearchGyan(value: boolean) {
        this.callPreviousSearchGyan.next(value);
    }

    // subject for create gyan inititate this will set up from search section.
    setCreateGyanInitiated(value: boolean) {
        this.createGyanInitiated.next(value);
    }

    setdisablehighlight(value: boolean) {
        this.disablehighlight.next(value);
    }

    setgotoDashboard(value: boolean) {
        this.gotoDashboard.next(value);
    }

    // subject for previous gyan on load page
    setArticleLongStory(value: boolean) {
        this.articleLongStory.next(value);
    }

    //placeholder for dashboard and search section
    setloadingAfterSocket(value: boolean) {
        this.loadingAfterSocket.next(value);
    }

    // subject for Calling MDS once we get message from socket
    setCallfromSocketForMDS(value: boolean) {
        this.callfromSocketForMDS.next(value);
    }

    // subject for Calling Article List once we get message from socket
    setCallfromSocketArticleList(value: boolean) {
        this.callfromSocketArticleList.next(value);
    }

    // subject for Calling Article List Summary once we get message from socket
    setCallfromSocketArticleListSummary(value: boolean) {
        this.callfromSocketArticleListSummary.next(value);
    }

    setResetArticleList(value: boolean) {
        this.resetArticleList.next(value);
    }

    setSelectedId(value: any) {
        this.SelectedId.next(value);
    }

    // subject for Find More Article click event
    setFindMoreArticleClick(value: boolean) {
        this.findMoreArticleClick.next(value);
    }

    // subject for previous gyan on load page
    setScrollToTop(value: boolean) {
        this.scrollToTop.next(value);
    }

    setopenSubmitGyan(value: boolean) {
        this.openSubmitGyan.next(value);
    }
    setReOpenAdvancedQueries(value: boolean) {
        this.ReOpenAdvancedQueries.next(value);
    }
    setRefreshAdvancedQueries(value: boolean) {
        this.RefreshAdvancedQueries.next(value);
    }

    setShowAdvancyQueryFormPage(value: boolean) {
        this.showAdvancyQueryFormPage.next(value);
    }

    setCallFromSocketForGyanStatus(value: object) {
        this.CallFromSocketForGyanStatus.next(value);
    }

    openMenu(id: number): void {
        this.menuStateSubject.next(id);
    }

    closeMenu(): void {
        this.menuStateSubject.next(null);
    }

    // subject for checking gyan input topic name in submit gyan page
    setTopicName(value: string) {
        this.callTopicName.next(value);
    }

    setGyanStatus(value: boolean) {
        this.GyanStatus.next(value);
    }

    callValidationForSubmitGyanFromSubtopic(value: boolean) {
        this.validationForSubmitGyanFromSubtopic.next(value);
    }

    setArticleCountButtonClicked(value: object) {
        this.articleCountButtonClicked.next(value);
    }

    setCancelFlag(value: boolean): void {
        this.cancelFlag.next(value);
    }

    setShowDraftListPage(value: boolean) {
        this.showDraftListPage.next(value);
    }

    setCallUseAsTemplate(value: object) {
        this.callUseAsTemplate.next(value);
    }

    setTemplateDataSubject(value: object) {
        this.templateDataSubject.next(value);
    }

    setTemplateDataSubjectForSources(value: object) {
        this.templateDataSubjectForSources.next(value);
    }

    setTemplateDataSubjectForTopicOutline(value: object) {
        this.templateDataSubjectForTopicOutline.next(value);
    }

    setTemplateDataSubjectForConfig(value: object) {
        this.templateDataSubjectForConfig.next(value);
    }

    setCreateUsergroupforClient(value: object) {
        this.createUserGroupForClient.next(value);
    }

    setConfirmGyan(value: boolean) {
        this.confirmGyan.next(value);
    }
    setDraftLoaded(value: any) {
        this.calldraftLoaded.next(value);
    }

    setTemplatetLoaded(value: boolean) {
        this.templateLoaded.next(value);
    }
}
